(() => {
  const initColorPicker = control => {
    const wrapper = control.parentElement;
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'kaching-bundles__bar-variant-select lvn-color-trigger';
    button.setAttribute('role', 'combobox'); button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-label', control.getAttribute('aria-label')); button.setAttribute('aria-expanded', 'false');
    const swatch = document.createElement('span'); swatch.className = 'kaching-bundles__swatch'; swatch.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span'); button.append(swatch, label);
    const panel = document.createElement('div'); panel.className = 'lvn-color-options'; panel.id = `${control.id}-colors`;
    panel.setAttribute('role', 'listbox'); panel.setAttribute('aria-label', control.getAttribute('aria-label')); panel.hidden = true;
    button.setAttribute('aria-controls', panel.id);
    let focused = control.selectedIndex;
    let search = '', lastKey = 0;
    const choices = [...control.options].map((option, index) => {
      const item = document.createElement('span'); item.id = `${panel.id}-${index}`; item.setAttribute('role', 'option');
      const circle = document.createElement('span'); circle.className = 'kaching-bundles__swatch'; circle.setAttribute('aria-hidden', 'true');
      circle.style.setProperty('--kaching-swatch-color', option.dataset.swatchColor || 'transparent');
      const name = document.createElement('span'); name.textContent = option.textContent; item.append(circle, name);
      item.addEventListener('click', event => { event.preventDefault(); choose(index); }); panel.append(item); return item;
    });
    const close = () => { panel.hidden = true; button.setAttribute('aria-expanded', 'false'); button.removeAttribute('aria-activedescendant'); };
    const highlight = index => {
      focused = index;
      choices.forEach((item, i) => item.classList.toggle('is-focused', i === index));
      button.setAttribute('aria-activedescendant', choices[index].id);
      choices[index].scrollIntoView({block:'nearest'});
    };
    const choose = index => {
      if (control.disabled || control.options[index].disabled) return;
      control.selectedIndex = index; control.dispatchEvent(new Event('change', {bubbles:true})); close(); button.focus();
    };
    const open = () => {
      if (control.disabled) return;
      document.dispatchEvent(new CustomEvent('lvn:color-open', {detail:button}));
      panel.hidden = false; button.setAttribute('aria-expanded', 'true'); highlight(control.selectedIndex);
      const rect = button.getBoundingClientRect();
      panel.style.left = `${Math.max(8, Math.min(rect.left, document.documentElement.clientWidth - panel.offsetWidth - 8))}px`;
      const below = window.innerHeight - rect.bottom - 8;
      const above = rect.top - 8;
      const height = Math.min(500, Math.max(below, above));
      panel.style.maxHeight = `${height}px`;
      panel.style.top = `${below >= Math.min(panel.scrollHeight, 500) || below >= above ? rect.bottom : Math.max(8, rect.top - Math.min(panel.scrollHeight, height))}px`;
    };
    button.addEventListener('click', event => { event.preventDefault(); panel.hidden ? open() : close(); });
    button.addEventListener('keydown', event => {
      if (event.key === 'Tab') { close(); return; }
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (['ArrowDown','ArrowUp','Home','End','Enter',' '].includes(event.key)) {
        event.preventDefault();
        if (panel.hidden) { open(); return; }
        if (event.key === 'Enter' || event.key === ' ') { choose(focused); return; }
        const enabled = [...control.options].map((o, i) => o.disabled ? -1 : i).filter(i => i >= 0);
        if (!enabled.length) return;
        const current = enabled.indexOf(focused);
        highlight(event.key === 'Home' ? enabled[0] : event.key === 'End' ? enabled.at(-1) : enabled[(current + (event.key === 'ArrowDown' ? 1 : -1) + enabled.length) % enabled.length]);
      } else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        event.preventDefault(); const now = Date.now(); search = now - lastKey > 600 ? event.key : search + event.key; lastKey = now;
        const index = [...control.options].findIndex(o => !o.disabled && o.textContent.toLocaleLowerCase('fr').startsWith(search.toLocaleLowerCase('fr')));
        if (index >= 0) { if (panel.hidden) open(); highlight(index); }
      }
    });
    document.addEventListener('click', event => { if (!wrapper.contains(event.target)) close(); });
    document.addEventListener('lvn:color-open', event => { if (event.detail !== button) close(); });
    document.addEventListener('scroll', event => { if (!panel.contains(event.target)) close(); }, true); window.addEventListener('resize', close);
    wrapper.append(button, panel); wrapper.classList.add('lvn-buyer-select--enhanced');
    control.tabIndex = -1;
    control.setAttribute('aria-hidden', 'true');
    return () => {
      button.disabled = control.disabled; label.textContent = control.selectedOptions[0]?.textContent || '';
      swatch.style.setProperty('--kaching-swatch-color', control.selectedOptions[0]?.dataset.swatchColor || 'transparent');
      choices.forEach((item, i) => { item.setAttribute('aria-selected', String(i === control.selectedIndex)); item.setAttribute('aria-disabled', String(control.options[i].disabled)); });
      if (control.disabled) close();
    };
  };
  const init = (root = document) => root.querySelectorAll('[data-lvn-product]').forEach(scope => {
    if (scope.dataset.initialized) return;
    scope.dataset.initialized = 'true';
    const delivery = scope.querySelector('[data-lvn-delivery]');
    if (delivery) {
      const today = new Date();
      const format = (offset, full = false) => { const date = new Date(today); date.setDate(today.getDate() + offset); return new Intl.DateTimeFormat('fr-FR', {day:'2-digit', month:'2-digit', ...(full ? {year:'numeric'} : {})}).format(date); };
      delivery.querySelector('.lma-delivery-estimate__dates').textContent = `${format(4,true)} - ${format(6,true)}`;
      const ranges = delivery.querySelectorAll('.lma-delivery-estimate__range');
      ranges[0].textContent = format(0); ranges[1].textContent = `${format(0)} - ${format(2)}`; ranges[2].textContent = `${format(4)} - ${format(6)}`;
    }
    const form = scope.querySelector('[data-lvn-product-form]');
    const data = scope.querySelector('[data-lvn-variants]');
    const variants = data ? JSON.parse(data.textContent) : [];
    const variantInput = form?.querySelector('[data-lvn-variant-id]') || form?.elements.id;
    // Without JS the noscript select is the only successful variant field.
    if (variantInput) variantInput.name = 'id';
    const options = form ? [...form.querySelectorAll('[data-lvn-option]')] : [];
    const colorPickers = new Map(options.filter(option => option.parentElement.classList.contains('lvn-buyer-select--color')).map(option => [option, initColorPicker(option)]));
    const cards = form ? [...form.querySelectorAll('[data-lvn-offer-card]')] : [];
    const offers = form ? [...form.querySelectorAll('[data-lvn-offer]')] : [];
    const message = form?.querySelector('[data-lvn-product-message]');
    const add = form?.querySelector('[name="add"]');
    let busy = false;
    const rowVariant = row => {
      const controls = [...row.querySelectorAll('[data-lvn-option]')];
      return controls.length ? variants.find(v => controls.every(control => String(v.options[Number(control.dataset.optionIndex)]) === control.value)) : variants.find(v => String(v.id) === variantInput?.value) || variants[0];
    };
    const activeCard = () => cards.find(card => String(card.dataset.lvnOfferCard) === (offers.find(offer => offer.checked)?.value || '1'));
    const chosenVariants = () => activeCard() ? [...activeCard().querySelectorAll('[data-lvn-variant-row]')].map(rowVariant) : [variants.find(v => String(v.id) === variantInput?.value) || variants[0]];
    const selected = () => chosenVariants()[0];
    const quantity = () => Number(form?.elements.quantity?.value ?? 1);
    const isBogo = Boolean(form?.dataset.lvnBogo);
    const offerPrice = choices => choices.reduce((sum, choice) => sum + (choice?.price || 0), 0) - (isBogo && choices.length === 2 ? Math.min(...choices.map(choice => choice?.price || 0)) : 0);
    const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: scope.dataset.currency || window.lvnCurrency || window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    const gallery = scope.querySelector('[data-lvn-gallery]');
    const images = gallery ? [...gallery.querySelectorAll('[data-lvn-gallery-image]')] : [];
    const thumbs = gallery ? [...gallery.querySelectorAll('[data-lvn-gallery-thumb]')] : [];
    const viewer = gallery?.querySelector('.lvn-native-gallery__images');
    const mobileGallery = window.matchMedia('(max-width: 749px)');
    let imageIndex = 0;
    const showImage = (index, scroll = true) => {
      if (!images.length) return;
      imageIndex = (index + images.length) % images.length;
      images.forEach((image, i) => { image.hidden = i !== imageIndex; image.classList.toggle('is-active', i === imageIndex); });
      thumbs.forEach((thumb, i) => { thumb.setAttribute('aria-pressed', String(i === imageIndex)); if (i === imageIndex) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current'); });
      if (scroll) {
        if (viewer && mobileGallery.matches) viewer.scrollTo({ left: images[imageIndex].offsetLeft - images[0].offsetLeft, behavior: 'smooth' });
        thumbs[imageIndex]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    };
    viewer?.addEventListener('scroll', () => {
      if (mobileGallery.matches && viewer.clientWidth) showImage(Math.round(viewer.scrollLeft / viewer.clientWidth), false);
    }, { passive: true });
    mobileGallery.addEventListener('change', () => showImage(imageIndex));
    const showVariantImage = variant => {
      const id = variant?.featured_image?.id;
      const index = id ? images.findIndex(image => String(image.dataset.imageId) === String(id)) : -1;
      // A color without its own photo must not keep the previously selected color's image.
      showImage(index >= 0 ? index : 0);
    };
    const updateVariant = (changeUrl = false, imageVariant) => {
      if (!form) return;
      const variant = selected();
      variantInput.value = variant ? variant.id : '';
      const choices = chosenVariants();
      const available = choices.length && choices.every(choice => choice?.available);
      add.disabled = busy || !available || !Number.isInteger(quantity()) || quantity() < 1 || quantity() > 999;
      form.querySelector('[data-lvn-add-label]').textContent = choices.some(choice => !choice) ? 'Indisponible' : available ? 'Ajouter au panier' : 'Épuisé';
      cards.forEach(card => {
        const active = card === activeCard();
        card.classList.toggle('kaching-bundles__bar--selected', active);
        card.classList.toggle('is-selected', active);
        card.querySelector('[data-lvn-offer-rows]').hidden = !active;
        const rows = [...card.querySelectorAll('[data-lvn-variant-row]')];
        rows.forEach(row => {
          const choice = rowVariant(row);
          row.querySelector('[data-lvn-row-status]').textContent = choice?.available ? '' : choice ? 'Épuisé' : 'Indisponible';
          row.querySelectorAll('[data-lvn-option]').forEach(control => {
            control.disabled = !active;
            const controls = [...row.querySelectorAll('[data-lvn-option]')];
            [...control.options].forEach(option => {
              // Earlier options constrain later ones; future choices must remain reachable.
              const optionIndex = Number(control.dataset.optionIndex);
              option.disabled = !variants.some(candidate => candidate.available && String(candidate.options[optionIndex]) === option.value && controls.filter(other => Number(other.dataset.optionIndex) < optionIndex).every(other => String(candidate.options[Number(other.dataset.optionIndex)]) === other.value));
            });
            const swatch = control.parentElement.querySelector('[data-lvn-color-swatch]');
            if (swatch) {
              swatch.style.backgroundColor = control.selectedOptions[0]?.dataset.swatchColor || 'transparent';
            }
            colorPickers.get(control)?.();
          });
        });
        const rowChoices = rows.map(rowVariant);
        const price = offerPrice(rowChoices);
        card.querySelector('[data-lvn-offer-price]').textContent = rowChoices.every(Boolean) ? money(price) : '—';
        const image = card.querySelector('[data-lvn-offer-image]');
        const featured = rowVariant(rows[0])?.featured_image;
        if (image && featured?.src) image.src = featured.src;
        const compare = card.querySelector('[data-lvn-compare]');
        const fullPrice = isBogo && rows.length === 2 ? rowChoices.reduce((sum, choice) => sum + (choice?.price || 0), 0) : rowVariant(rows[0])?.compare_at_price;
        compare.hidden = isBogo ? rows.length !== 2 || !rowChoices.every(Boolean) : rows.length !== 1 || !(fullPrice > price);
        compare.textContent = fullPrice ? money(fullPrice) : '';
      });
      const total = form.querySelector('[data-lvn-total]');
      if (total) {
        total.hidden = isBogo;
        form.querySelector('[data-lvn-total-price]').textContent = choices.every(Boolean) && Number.isInteger(quantity()) && quantity() > 0 ? money(offerPrice(choices) * quantity()) : '—';
        form.querySelector('[data-lvn-quantity-label]').textContent = choices.length === 2 ? 'Quantité de paires' : 'Quantité';
      }
      if (variant) {
        const banner = scope.querySelector('.lvn-autumn-banner');
        if (banner) {
          banner.hidden = !(variant.compare_at_price > variant.price);
          banner.querySelector('[data-lvn-banner-saving]').textContent = money(variant.compare_at_price - variant.price);
          banner.querySelector('[data-lvn-banner-compare]').textContent = money(variant.compare_at_price);
          banner.querySelector('[data-lvn-banner-price]').textContent = money(variant.price);
        }
        if (!cards.length) {
          form.querySelector('[data-lvn-price]').textContent = money(variant.price);
          const compare = form.querySelector('[data-lvn-compare]');
          compare.hidden = !(variant.compare_at_price > variant.price);
          compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
        }
        if (changeUrl) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
          showVariantImage(imageVariant || variant);
        }
      }
    };
    options.forEach(option => option.addEventListener('change', () => updateVariant(true, rowVariant(option.closest('[data-lvn-variant-row]')))));
    offers.forEach(offer => offer.addEventListener('change', () => updateVariant(true)));
    form?.elements.quantity?.addEventListener('input', () => updateVariant());
    if (form) {
      cards.forEach(card => { card.hidden = false; });
      offers.forEach(offer => { offer.disabled = false; });
      const requested = new URL(location.href).searchParams.get('variant');
      const initial = variants.find(v => String(v.id) === requested);
      if (initial) {
        options.forEach(option => { option.value = initial.options[Number(option.dataset.optionIndex)]; });
        variantInput.value = initial.id;
      }
      updateVariant();
      if (initial) showVariantImage(initial);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const choices = chosenVariants();
        const count = quantity();
        if (busy || !choices.length || !choices.every(choice => choice?.available) || !Number.isInteger(count) || count < 1 || count > 999 || !form.reportValidity()) return;
        busy = true;
        add.disabled = true;
        add.setAttribute('aria-busy', 'true');
        form.querySelector('[data-lvn-loading]').hidden = false;
        form.querySelector('[data-lvn-add-label]').hidden = true;
        message.hidden = true;
        try {
          const addUrl = (form.dataset.addUrl || window.lvnRoutes?.cart_add_url || '/cart/add').replace(/\.js$/, '') + '.js';
          // Merge equal selections. One native request submits all independently chosen lines.
          const items = [];
          choices.forEach((choice, index) => {
            const existing = !isBogo && items.find(item => item.id === choice.id);
            if (existing) existing.quantity += count;
            else items.push({ id: choice.id, quantity: count, ...(isBogo && choices.length === 2 ? {properties:{_lvn_offer_line:String(index+1)}} : {}) });
          });
          const response = await fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Impossible d’ajouter ce produit.');
          message.textContent = 'Produit ajouté au panier.';
          message.hidden = false;
          form.querySelector('[data-lvn-cart-link]').hidden = false;
          // A cart refresh failure must not invite a second add after the successful mutation.
          try {
            const cartResponse = await fetch(window.lvnRoutes?.cart_json_url || '/cart.js', { headers: { Accept: 'application/json' } });
            if (!cartResponse.ok) throw new Error('Cart refresh failed');
            const cart = await cartResponse.json();
            if (window.lvnRefreshCart) await window.lvnRefreshCart();
            else document.dispatchEvent(new CustomEvent('lvn:cart-updated', { detail: cart }));
            const drawer = document.getElementById('LvnCart');
            if (drawer && !drawer.open) drawer.showModal();
          } catch { message.textContent = 'Produit ajouté. Consultez votre panier pour continuer.'; }
        } catch (error) {
          // Shopify can accept available stock and still return 422; a network error is also uncertain.
          // Read the real cart before inviting a retry. Never repeat or roll back this POST.
          message.textContent = (error.message || 'Erreur réseau.') + ' Vérifiez les quantités de votre panier avant de réessayer.';
          message.hidden = false;
          form.querySelector('[data-lvn-cart-link]').hidden = false;
          try {
            const response = await fetch(window.lvnRoutes?.cart_json_url || '/cart.js', { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Cart refresh failed');
            const cart = await response.json();
            document.dispatchEvent(new CustomEvent('lvn:cart-updated', { detail: cart }));
          } catch { message.textContent += ' Le panier n’a pas pu être actualisé.'; }
        } finally {
          busy = false;
          add.removeAttribute('aria-busy');
          form.querySelector('[data-lvn-loading]').hidden = true;
          form.querySelector('[data-lvn-add-label]').hidden = false;
          updateVariant();
        }
      });
    }
    gallery?.addEventListener('click', event => {
      const thumb = event.target.closest('[data-lvn-gallery-thumb]');
      if (thumb) showImage(Number(thumb.dataset.galleryIndex));
      if (event.target.closest('[data-lvn-gallery-prev]')) showImage(imageIndex - 1);
      if (event.target.closest('[data-lvn-gallery-next]')) showImage(imageIndex + 1);
      const dialog = gallery.querySelector('[data-lvn-gallery-dialog]');
      if (event.target.closest('[data-lvn-gallery-open]')) {
        const source = images[imageIndex].querySelector('img');
        dialog.querySelector('img').src = source.src;
        dialog.querySelector('img').alt = source.alt;
        if (!dialog.open) dialog.showModal();
      }
      if (event.target.closest('[data-lvn-gallery-close]') || event.target === dialog) dialog.close();
    });
    gallery?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(imageIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    scope.querySelectorAll('[data-lvn-product-share]').forEach(share => {
      const details = share.querySelector('details');
      const summary = share.querySelector('summary');
      const input = share.querySelector('[data-lvn-share-url]');
      const status = share.querySelector('[data-lvn-share-status]');
      const closeButton = share.querySelector('[data-lvn-share-close]');
      let state = 0;
      const reset = () => { state++; status.textContent = ''; closeButton.classList.add('hidden'); };
      const close = () => { details.open = false; reset(); summary.focus(); };
      input.addEventListener('focus', () => input.select());
      details.addEventListener('toggle', reset);
      share.addEventListener('keydown', event => { if (event.key === 'Escape' && details.open) { event.preventDefault(); close(); } });
      closeButton.addEventListener('click', close);
      share.querySelector('[data-lvn-share-copy]').addEventListener('click', async () => {
        const requestState = state;
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(input.value);
          if (!details.open || state !== requestState) return;
          status.textContent = 'Lien copié.';
          closeButton.classList.remove('hidden');
          closeButton.focus();
        } catch {
          if (!details.open || state !== requestState) return;
          status.textContent = 'Copie indisponible. Sélectionnez le lien et copiez-le manuellement.';
          input.focus(); input.select();
        }
      });
    });
    const guide = scope.querySelector('[data-lvn-size-dialog]');
    const categories = { 'brassiere-luveon': 'bra', 'debardeur-luveon': 'top', 'tee-shirt-3d': 'tshirt' };
    const category = categories[location.pathname.split('/').filter(Boolean).pop()] || 'legging';
    guide?.querySelectorAll('[data-luv-sg-quiz-group], [data-luv-sg-table-group]').forEach(group => { group.hidden = (group.dataset.luvSgQuizGroup || group.dataset.luvSgTableGroup) !== category; });
    const result = guide?.querySelector('#luv-sg-result');
    const showSize = size => {
      if (!size || !result) return;
      result.classList.add('is-visible');
      guide.querySelector('#luv-sg-result-size').textContent = size;
    };
    scope.addEventListener('click', event => {
      if (event.target.closest('[data-luveon-size-guide]')) {
        guide.classList.add('is-open');
        if (!guide.open) guide.showModal();
      }
      if (event.target.closest('[data-luv-sg-close]') || event.target === guide) guide.close();
      const tab = event.target.closest('[data-luv-sg-tab]');
      if (tab) {
        guide.querySelectorAll('[data-luv-sg-tab]').forEach(item => { const active = item === tab; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); });
        guide.querySelectorAll('[data-luv-sg-panel]').forEach(panel => { const active = panel.dataset.luvSgPanel === tab.dataset.luvSgTab; panel.classList.toggle('is-active', active); panel.hidden = !active; });
      }
      const pill = event.target.closest('[data-size-pill]');
      if (pill) {
        pill.parentElement.querySelectorAll('[data-size-pill]').forEach(item => { item.classList.toggle('is-selected', item === pill); item.setAttribute('aria-pressed', String(item === pill)); });
        showSize(pill.dataset.size);
      }
      const toggle = event.target.closest('[data-luv-sg-toggle-detail]');
      if (toggle) {
        const detail = toggle.closest('.luv-sg-quiz-group').querySelector('[data-luv-sg-detail]');
        const open = !detail.classList.contains('is-open');
        detail.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      }

    });
    guide?.addEventListener('close', () => guide.classList.remove('is-open'));
    guide?.addEventListener('keydown', event => {
      if (!event.target.matches('[data-luv-sg-tab]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const tabs = [...guide.querySelectorAll('[data-luv-sg-tab]')];
      const current = tabs.indexOf(event.target);
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      event.preventDefault(); tabs[index].focus(); tabs[index].click();
    });
    guide?.addEventListener('input', event => {
      if (!event.target.matches('[data-measure]')) return;
      const group = event.target.closest('[data-luv-sg-quiz-group]');
      const fields = [...group.querySelectorAll('[data-measure]')];
      if (fields.some(field => field.value && !field.checkValidity())) return;
      const order = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
      const thresholds = { waist: [60, 69, 80, 89, 99, 110, 120, 129], hips: [85, 94, 106, 115, 122, 130, 141, 150], bust: [83, 88, 93, 98, 103, 108, 113, 118] };
      const sizes = fields.filter(field => Number(field.value) > 0).map(field => { const index = thresholds[field.dataset.measure].findIndex(limit => Number(field.value) <= limit); return index < 0 ? 8 : index; });
      if (sizes.length) showSize(order[Math.max(...sizes)]);
    });
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }), { threshold: 0.1 });
    scope.querySelectorAll('video:not([data-lma-vt-video])').forEach(video => {
      observer.observe(video);
      const reset = () => { const card = video.closest('.lma-vt__card'); card?.classList.remove('is-playing'); card?.querySelector('[data-lma-vt-play]')?.setAttribute('aria-label', 'Lire la vidéo'); };
      video.addEventListener('pause', reset);
      video.addEventListener('ended', reset);
    });
    const unload = event => { if (event.target.contains(scope)) { observer.disconnect(); document.removeEventListener('shopify:section:unload', unload); } };
    document.addEventListener('shopify:section:unload', unload);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
